import 'core-js/modules/es6.reflect.construct.js';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import cx from 'classnames';
import * as React from 'react';
import { Button } from '@blueprintjs/core';
import { DATEPICKER_NAVBAR } from './common/classes.js';
import { areSameMonth } from './common/dateUtils.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DatePickerNavbar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DatePickerNavbar, _React$PureComponent);

  var _super = _createSuper(DatePickerNavbar);

  function DatePickerNavbar() {
    var _this;

    _classCallCheck(this, DatePickerNavbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleNextClick = function () {
      return _this.props.onNextClick();
    };

    _this.handlePreviousClick = function () {
      return _this.props.onPreviousClick();
    };

    return _this;
  }

  _createClass(DatePickerNavbar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classNames,
          month = _this$props.month,
          maxDate = _this$props.maxDate,
          minDate = _this$props.minDate;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(DATEPICKER_NAVBAR, classes.navBar)
      }, this.props.hideLeftNavButton || /*#__PURE__*/React.createElement(Button, {
        className: classes.navButtonPrev,
        disabled: areSameMonth(month, minDate),
        icon: "chevron-left",
        minimal: true,
        onClick: this.handlePreviousClick
      }), this.props.hideRightNavButton || /*#__PURE__*/React.createElement(Button, {
        className: classes.navButtonNext,
        disabled: areSameMonth(month, maxDate),
        icon: "chevron-right",
        minimal: true,
        onClick: this.handleNextClick
      }));
    }
  }]);

  return DatePickerNavbar;
}(React.PureComponent);

export { DatePickerNavbar };
//# sourceMappingURL=datePickerNavbar.js.map
